import { FC, useEffect, useRef } from 'react';
import ReactNotificationAlert, { AlertOptions } from 'react-notification-alert';
import { useDispatch, useSelector } from 'react-redux';
import { emptyString } from '~/constants/string';
import { clearNotification } from '~/store/main';
import { notificationSelector } from '~/store/main/selectors';

const defaultTimeout = 3;

const defaultOptions: AlertOptions = {
  place: 'tr',
  message: emptyString,
  type: 'success',
  icon: emptyString,
  autoDismiss: defaultTimeout,
};

const Alert: FC = () => {
  const refNotification = useRef<any>(null);
  const dispatch = useDispatch();

  const notification = useSelector(notificationSelector);

  const options = {
    ...defaultOptions,
    ...notification,
  };

  useEffect(() => {
    if (notification.message) {
      refNotification.current.notificationAlert(options);
    }

    const clear = () => {
      setTimeout(() => {
        dispatch(clearNotification());
      }, options?.autoDismiss || defaultTimeout);
    };

    if (notification.message) {
      clear();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification.message]);

  return <ReactNotificationAlert ref={refNotification} />;
};

export default Alert;
